export default class Modifiers implements HourPrice.Modifiers {
  tax: boolean = true;
  officeService: boolean = true;
  administration: boolean = true;
  depreciation: boolean = true;

  constructor (props: HourPrice.Modifiers = {}) {
    Object.assign(this, props)
  }
}
